import React from 'react';
import Home from './page/Home/home';
import About from './page/About'; // Import About normally
import Layout from './layout/mainlayout';
import DashboardLayout from './layout/dashboardLayout';
import ProductDetails from './page/productDetails';
import { useRoutes } from 'react-router-dom';
import ServicesPage from './page/ServicesPage/servicesPage';
import Products from './page/Products/products';
import ProductsDetails from './page/Products/ProductDetails';
import ContactUs from './page/Contact/Contact';
import AuthLayout from './layout/authLayout';
import HomeDashboard from './page/dashboardPages/home';
import ProductsDashboard from './page/dashboardPages/products';
import AddProduct from './page/dashboardPages/products/subPages/addProduct';
import EditProduct from './page/dashboardPages/products/subPages/editProduct';
import NotFound from './page/NotFound';
import News from './page/News/News';
import CategoryPage from './page/Products/sections/CategoryPage';
import NewsDetails from './page/News/newsDetails/newsDetails';
import NewsAdmin from './page/dashboardPages/news/news';




export default function Router() {

  const Routes = useRoutes([
    {
      path: '/',
      element: <Layout />,
      children: [
        { path: '/', element: <Home /> },
        {
          path: 'about-us', // Remove the leading slash here
          element: (
            <About/>
          ),
          children: [
            { path: 'data', element: <ProductDetails /> }, // Remove the leading slash here

          ]
        },
        {
          element:<Products/>,
          path:"/product",
        },
        {
          element:<CategoryPage/>,
          path:"/product/:Category"
        },
        {
          element:<ProductsDetails/>,
          path:"/productdetails/:id"
        },
        {
          element:<ServicesPage/>,
          path:"/service"
        },
        {
          element:<ContactUs/>,
          path:"/contact-us"
        },
        {
          element:<News />,
          path:"/news"
        },
        {
          element:<NewsDetails />,
          path:"/news/:id"
        }
      ],
    },
    {
      path:'/dashboard',
      children:[
        {path:'/dashboard/',element:<AuthLayout/>},
        {path:'/dashboard/main',element:<DashboardLayout/>,children:[
          {path:'/dashboard/main/',element:<HomeDashboard/>},
          {path:'/dashboard/main/product',element:<ProductsDashboard/>},
          {path:'/dashboard/main/product/addproduct',element:<AddProduct/>},
          {path:'/dashboard/main/product/editproduct/:id',element:<EditProduct/>},
          {path:'/dashboard/main/news',element:<NewsAdmin/>},
        ]},
      ]
    },
    {
      path:"*",
      element:<NotFound />,
    }
  ]);

  return Routes
}


  
